import { render } from "./PortalButton.vue?vue&type=template&id=6ffea2f2&scoped=true"
import script from "./PortalButton.vue?vue&type=script&lang=js"
export * from "./PortalButton.vue?vue&type=script&lang=js"

import "./PortalButton.vue?vue&type=style&index=0&id=6ffea2f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffea2f2"]])

export default __exports__